import React from 'react'
import { BiCalendarCheck, BiCalendarHeart, BiCalendarX } from 'react-icons/bi'
import { AuthContext } from '../../../contexts/AuthContext'
import { CalClock } from '../../../assets'
import RouterHook from '../../../contexts/RouterHook'
import EventRepeatRoundedIcon from '@mui/icons-material/EventRepeatRounded'
import moment from 'moment'

import './stylesCPed.css'

export default function CompPedido({ pedido }) {
  const { sttAuthCtx } = React.useContext(AuthContext)
  const serverRouter = RouterHook()

  const quadra = pedido.quadra

  /* padrão de cores!
    colorSolicitado: '#ff7043',
    colorReservado: '#24ad49',
    colorRealizado: '#00cda4',
    colorCancelado: '#bf3324',
  */

  function ActionPageAgendamento() {
    serverRouter('agendamento', pedido.idpedido)
  }

  function ReturnFalta() {
    const falta = moment(pedido.dataInicio).startOf('minute').fromNow().toUpperCase()
    switch (pedido.status) {
      case 'SOLICITADO':
        return (
          <div className='contain-btt-pedido-infos-line'>
            {!sttAuthCtx.isMobile && <img src={CalClock} alt='' style={{ color: '#ff7043', width: '25px', height: '25px' }} />}
            <h3 className={'text-states-header'} style={{ color: '#ff7043' }}>
              {falta}
            </h3>
          </div>
        )
      case 'AGENDADO':
        return (
          <div className='contain-btt-pedido-infos-line'>
            {!sttAuthCtx.isMobile && <BiCalendarHeart size={25} color='#22ac4a' />}
            <h3 className={'text-states-header'} style={{ color: '#22ac4a' }}>
              {falta}
            </h3>
          </div>
        )
      case 'CANCELADO':
        return (
          <div className='contain-btt-pedido-infos-line'>
            {!sttAuthCtx.isMobile && <BiCalendarX size={25} color='#bf3324' />}
            <h3 className={'text-states-header'} style={{ color: '#bf3324' }}>
              {falta}
            </h3>
          </div>
        )
      case 'REALIZADO':
        return (
          <div className='contain-btt-pedido-infos-line'>
            {!sttAuthCtx.isMobile && <BiCalendarCheck size={25} color='#00cda4' />}
            <h3 className={'text-states-header'} style={{ color: '#00cda4' }}>
              {falta}
            </h3>
          </div>
        )
    }
  }

  function ReturnContainPedido(status) {
    switch (status) {
      case 'SOLICITADO':
        return 'btt-pedido-comp btt-gradient-solicitado'
      case 'AGENDADO':
        return 'btt-pedido-comp btt-gradient-agendado'
      case 'CANCELADO':
        return 'btt-pedido-comp btt-gradient-cancelado'
      case 'REALIZADO':
        return 'btt-pedido-comp btt-gradient-realizado'
    }
  }

  function ReturnStatus(status) {
    switch (status) {
      case 'SOLICITADO':
        return <h3 style={{ color: '#ff7043' }}>{status}</h3>
      case 'AGENDADO':
        return <h3 style={{ color: '#22ac4a' }}>{status}</h3>
      case 'CANCELADO':
        return <h3 style={{ color: '#bf3324' }}>{status}</h3>
      case 'REALIZADO':
        return <h3 style={{ color: '#00cda4' }}>{status}</h3>
    }
  }

  return (
    <button
      className={ReturnContainPedido(pedido.status)}
      onClick={() => {
        ActionPageAgendamento()
      }}
    >
      <div className='contain-btt-pedido-infos left-pedido'>
        {ReturnFalta()}
        <h1 className='text-infos-negrito'>{moment(pedido.dataInicio).format('HH:mm') + ' às ' + moment(pedido.dataFinal).format('HH:mm')}</h1>
        <h4>{moment(pedido.dataInicio).format('dddd, DD/MM/YYYY')}</h4>
        {ReturnStatus(pedido.status)}
      </div>
      <div className='contain-btt-pedido-infos right-pedido'>
        {pedido.mensalista_idmensalista !== null && (
          <div className='contain-label-hf'>
            <EventRepeatRoundedIcon className='icon-label-hf' />
            <p>Horário Fixo</p>
          </div>
        )}
        <h1 className='text-infos-negrito' style={{ fontSize: '14px' }}>
          {quadra.descricao}
        </h1>
        <p style={{ fontFamily: 'jost-light' }}>{pedido.empresa?.nome || pedido.quadra.empresa.nome}</p>
        <h2>
          {pedido.valorTotal !== null
            ? pedido.valorDesconto > 0
              ? `R$${(pedido.valorTotal - pedido.valorDesconto).toFixed(2).toString().replace('.', ',')}`
              : `R$${pedido.valorTotal.toFixed(2).toString().replace('.', ',')}`
            : 'R$0,00'}
        </h2>
      </div>
    </button>
  )
}
